module.exports = __webpack_public_path__ + "static/media/IMG_0262.21dcd7b7.JPG";